import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import SkeletonCardFields from '../../../../components/Loading/SkeletonCardFields/SkeletonCardFields';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  Box
} from '@material-ui/core';
import {
  convertToLocalTimeWhileIgnoringOffset,
  convertToDateOnlyString
} from 'helpers/timeUtils';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  },
  inputGrid: {},
  dateField: {
    width: '100%'
  }
}));

const Schedule = props => {
  const { className, staticContext, campaign, back, showNav, ...rest } = props;
  const {
    saveCampaign,
    goBack,
    thisCampaign,
    handleChange,
    onBlur,
    onFocus,
    shouldShowError,
    getErrorMessage,
    isLoading,
    isCampaignReadOnly
  } = campaign;
  const classes = useStyles();

  const handleDateChange = (newDate, fieldName) => {
      handleChange({
        target: {
          name: fieldName,
          value: convertToDateOnlyString(newDate)
        }
      });
  };

  const SkeletonCardContent = props => {
    return (
      <CardContent>
        <Grid container spacing={0}>
          <SkeletonCardFields numberOfRows={2} />
        </Grid>
      </CardContent>
    );
  };

  const startDate = convertToLocalTimeWhileIgnoringOffset(
    thisCampaign.startDate
  );
  const endDate = convertToLocalTimeWhileIgnoringOffset(thisCampaign.endDate);
  const minDate = moment().format('YYYY-MM-DD')

  const labels = {
    begin: 'Begin campaign on',
    end: 'End campaign on'
  };

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <CardHeader
            subheader=""
            title="Active Dates"
            titleTypographyProps={{ variant: 'h1' }}
          />
          <Divider />
          {isLoading && <SkeletonCardContent />}

          {!isLoading && (
            <CardContent>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Grid item md={6} xs={12} className={classes.inputGrid}>
                      <KeyboardDatePicker
                        margin="none"
                        className={classes.dateField}
                        id="startDate"
                        label={labels.begin}
                        format="MM/DD/YYYY"
                        minDate={minDate}
                        name="startDate"
                        value={startDate}
                        onChange={newDate =>
                          handleDateChange(newDate, 'startDate')
                        }
                        onFocus={onFocus}
                        onBlur={onBlur}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        error={shouldShowError('startDate')}
                        helperText={getErrorMessage('startDate')}
                        disabled={isCampaignReadOnly()}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid item md={6} xs={12} className={classes.inputGrid}>
                      <KeyboardDatePicker
                        margin="none"
                        className={classes.dateField}
                        id="endDate"
                        label={labels.end}
                        format="MM/DD/YYYY"
                        name="endDate"
                        value={endDate}
                        minDate={thisCampaign.startDate >= minDate ? startDate : minDate}
                        onChange={newDate =>
                          handleDateChange(newDate, 'endDate')
                        }
                        onFocus={onFocus}
                        onBlur={onBlur}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                        error={shouldShowError('endDate')}
                        helperText={getErrorMessage('endDate')}
                        disabled={isCampaignReadOnly()}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </MuiPickersUtilsProvider>
            </CardContent>
          )}
          {(back || showNav) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button
                  color="secondary"
                  variant="contained"
                  linkTo={back}
                  onClick={goBack}>
                  Back
                </Button>
                <Box flexGrow={1}>&nbsp;</Box>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={saveCampaign}>
                  Save Campaign
                </Button>
              </CardActions>
            </>
          )}
        </form>
      </Card>
    </div>
  );
};

export default Schedule;
